// src/screens/PrivacyPolicyPage.jsx
import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const PrivacyPolicyPage = () => {
  return (
    <>
      <Header />
      <div className="page-with-footer">
        <main className="page-main">
          <div className="site-shell">
            <div className="site-shell-inner">

              <section className="pt-5 pb-2 text-center">
                <h1 className="fw-bold display-5 mb-3" style={{color: "#A30003" }}>Política de Privacidad</h1>
                <p className="text-muted fs-5 mx-auto" style={{ maxWidth: "900px", color: "#A30003" }}>
                  En <strong>AltaModa</strong>{" "} protegemos tu información con responsabilidad y confidencialidad.
                </p>
              </section>

              <section className="pt-3 pb-5">
                <div className="row justify-content-center">
                  <div className="col-lg-9">

                    <p className="fs-5 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      Los datos suministrados se utilizan únicamente para gestionar pedidos, brindar asesoría y mantener comunicación con el cliente.
                    </p>

                    <p className="fs-5 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      No compartimos información personal con terceros, salvo cuando sea requerido por ley.
                    </p>

                  </div>
                </div>
              </section>

            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicyPage;
